<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          ORM Message Details
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                v-model="value.uid"
                placeholder="UID"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                v-model="value.messageNo"
                placeholder="Message No."
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageTypeEnum">
                  <option value="">-- Message Type --</option>
                  <option :value="messageTypeEnum.QML_Unknown">QML Unknown</option>
                  <option :value="messageTypeEnum.QML_RequestForQuote">Request For Quote</option>
                  <option :value="messageTypeEnum.QML_ScopeOfWork">Scope Of Work</option>
                  <option :value="messageTypeEnum.QML_DeclinedRepair">Declined Repair</option>
                  <option :value="messageTypeEnum.QML_Quote">QML Quote</option>
                  <option :value="messageTypeEnum.QML_AuthorityWithdrawn">Authority Withdrawn</option>
                  <option :value="messageTypeEnum.QML_JobCancelled">Job Cancelled</option>
                  <option :value="messageTypeEnum.QML_TotalLoss">Total Loss</option>
                  <option :value="messageTypeEnum.QML_TaxInvoice">Tax Invoice</option>
                  <option :value="messageTypeEnum.QML_AdjustmentNote">Adjustment Note</option>
                  <option :value="messageTypeEnum.QML_ReactivateInvoice">Reactivate Invoice</option>
                  <option :value="messageTypeEnum.QML_PaymentAuthorised">Payment Authorised</option>
                  <option :value="messageTypeEnum.QML_PaymentDeclined">Payment Declined</option>
                  <option :value="messageTypeEnum.QML_Error">Error</option>

                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageStatusTypeEnum">
                  <option value="">-- Message Status --</option>
                  <option :value="messageStatusTypeEnum.ToSend">To Send</option>
                  <option :value="messageStatusTypeEnum.Sent">Sent</option>
                  <option :value="messageStatusTypeEnum.UnRead">UnRead</option>
                  <option :value="messageStatusTypeEnum.Read">Read</option>
                  <option :value="messageStatusTypeEnum.Failed">Failed</option>
                  <option :value="messageStatusTypeEnum.InComplete">In Complete</option>
                  <option :value="messageStatusTypeEnum.Deleted">Deleted</option>
                  <option :value="messageStatusTypeEnum.DeletedRecord">Deleted Record</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageDirection">
                  <option value="">-- Message Direction --</option>
                  <option value="0">Incoming</option>
                  <option value="1">Outgoing</option>
                </select>
              </div>
            </div>
          </div>

        </li>
      </ul>
      <hr>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import { MessageStatusTypes, MessageTypes } from '@/enums'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'OrmMessageNewSideMenu',
  components: {
    AppSideMenu
  },
  props: {},
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      value: {
      messageStatusTypeEnum: 30,
      messageDirection: 0,
      messageTypeEnum: 1
    }
    }
  },
  computed: {
    messageStatusTypeEnum() {
      return MessageStatusTypes
    },
    messageTypeEnum() {
      return MessageTypes
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  }
}
</script>
